import { render, staticRenderFns } from "./LoginSumut.vue?vue&type=template&id=a5008650&lang=pug"
import script from "./LoginSumut.vue?vue&type=script&lang=js"
export * from "./LoginSumut.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/sumut/login-sumut.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports